const defaultState = {
  firstName: '',
  isSubmitting: false,
  lastName: '',
  userName: '',
  password: '',
  showPasswordStrength: false,
  passwordStrength: {
    message: '',
    strength: '',
    color: '',
  },
  passwordColor: '',
  passwordMessage: '',
  serverMessage: '',
  hasSuccessfullyCreatedAccount: false,
};

const register = (state = defaultState, action) => {
  switch (action.type) {
    case 'CREATING_ACCOUNT':
      return Object.assign({}, state, { isSubmitting: true });
    case 'REGISTRATION_SUCCESS':
      return Object.assign({}, state, {
        hasSuccessfullyCreatedAccount: true,
        isSubmitting: false,
      });
    case 'REGISTRATION_FAILURE': {
      const newState = Object.assign({}, state, {
        isSubmitting: false,
      });
      newState.serverMessage = action.value;
      return newState;
    }
    default:
      return state;
  }
};

export default register;
